import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFrasesPlantelService,
  createFrasePlantelService,
  updateFrasePlantelService,
  toggleFrasePlantelActiveService,
  getSubFrasesPlantelService,
  createSubFrasePlantelService,
  updateSubFrasePlantelService,
  toggleSubFrasePlantelActiveService,
} from "../../services/preguntasTalento/preguntasTalentoPlantel.service";

const msg = (error, fallback) =>
  error.response?.data?.message ||
  error.response?.data?.detail ||
  fallback;

// FRASES PLANTEL ---------------------------------------------
export const fetchFrasesPlantelThunk = createAsyncThunk(
  "preguntasTalentoPlantel/fetchFrases",
  async (params, { rejectWithValue }) => {
    try { return await getFrasesPlantelService(params); }
    catch (e) { return rejectWithValue(msg(e, "Error al listar frases")); }
  }
);

export const createFrasePlantelThunk = createAsyncThunk(
  "preguntasTalentoPlantel/createFrase",
  async (payload, { rejectWithValue }) => {
    try { return await createFrasePlantelService(payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al crear frase")); }
  }
);

export const updateFrasePlantelThunk = createAsyncThunk(
  "preguntasTalentoPlantel/updateFrase",
  async ({ id, payload }, { rejectWithValue }) => {
    try { return await updateFrasePlantelService(id, payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al actualizar frase")); }
  }
);

export const toggleFrasePlantelActiveThunk = createAsyncThunk(
  "preguntasTalentoPlantel/toggleFrase",
  async (id, { rejectWithValue }) => {
    try { return await toggleFrasePlantelActiveService(id); }
    catch (e) { return rejectWithValue(msg(e, "Error al cambiar estado")); }
  }
);

// SUB-FRASES PLANTEL -----------------------------------------
export const fetchSubFrasesPlantelThunk = createAsyncThunk(
  "preguntasTalentoPlantel/fetchSubFrases",
  async (params, { rejectWithValue }) => {
    try { return await getSubFrasesPlantelService(params); }
    catch (e) { return rejectWithValue(msg(e, "Error al listar sub-frases")); }
  }
);

export const createSubFrasePlantelThunk = createAsyncThunk(
  "preguntasTalentoPlantel/createSubFrase",
  async (payload, { rejectWithValue }) => {
    try { return await createSubFrasePlantelService(payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al crear sub-frase")); }
  }
);

export const updateSubFrasePlantelThunk = createAsyncThunk(
  "preguntasTalentoPlantel/updateSubFrase",
  async ({ id, payload }, { rejectWithValue }) => {
    try { return await updateSubFrasePlantelService(id, payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al actualizar sub-frase")); }
  }
);

export const toggleSubFrasePlantelActiveThunk = createAsyncThunk(
  "preguntasTalentoPlantel/toggleSubFrase",
  async (id, { rejectWithValue }) => {
    try { return await toggleSubFrasePlantelActiveService(id); }
    catch (e) { return rejectWithValue(msg(e, "Error al cambiar estado")); }
  }
);
